import { useContext } from 'react';
import { Helmet } from 'react-helmet';
import AppContext from 'AppContext';
import styled from 'styled-components';
import { Nav } from 'components/base/nav';
import PartnerBanner from 'components/pages/about/partnerbanner';
import Signups from 'components/pages/about/signup';
import Header from 'components/pages/homepage/homepageheader';
import Content from 'components/utilities/components/Content';
import HorizontalTimeline from 'components/utilities/components/HorizontalTimeline';
import Slides from 'components/utilities/slides';
import { theme } from 'components/utilities/utils';
import Footer from 'components/views/FooterView';
import ProgramSection from 'components/views/ProgramSection';
import Subheader from 'components/views/Subheader';
import FaqComponent from 'components/views/faq';
import WorkshopsView from 'components/views/workshopsview';

const Section = styled.section`
  text-align: center;
  padding: 0px;
  background: ${(props) => props.theme.colors.white};
  max-width: 1280px;
  .HeaderImage > img {
    @media (max-width: 768px) {
      max-width: 410px;
      bottom: 176px;
      position: absolute;
      right: 0px;
    }
  }
  .image2 {
    margin-top: -15px;
    height: 66px;
  }
`;

const Partners = styled(PartnerBanner)`
  padding: 50px 40px 0;
`;

export default function FutureSkills() {
  const { content, programs } = useContext(AppContext);
  return (
    <Section>
      <Helmet>
        <title>Parkdale Centre for Innovation</title>
        <meta
          name="description"
          content="Grow your idea, join a community, get traction, and see your project through at Parkdale Centre"
        />
        <meta property="og:title" content="Parkdale Centre" />
        <meta property="og:image" content="images/previews/incubators.png" />
        <meta
          property="og:url"
          content="https://www.parkdaleinnovates.org/programs"
        />
        <meta property="og:type" content="article" />
        <meta
          property="og:title"
          content="Incubate your Startup, Business or Career at Parkdale Centre."
        />
        <meta
          property="og:description"
          content="Grow your idea, get traction, and scale your work at Parkdale Centre. You bring the motivation."
        />
        <meta property="og:image" content="images/previews/incubators.png" />
      </Helmet>
      <Header
        pageName="futureskills"
        color={
          content.programs.Headers['Header text background color'] ||
          theme.colors.purple4
        }
        nav={<Nav />}
        showNavigation
        showLanguageSelector
      />
      <Subheader
        pageName="futureskills"
        section="SubHeaders"
        lcolor2="red"
        rcolor1={theme.colors.white}
        borderleft={theme.colors.gray5}
        borderright="transparent"
      />
      <WorkshopsView />
      <Slides pageName="futureskills" section="Carousel1" size="joint" />
      <HorizontalTimeline
        pageName="futureskills"
        listName="Timeline"
        titleName="Hero"
      />
      <Content
        content={
          programs.futureskills1 ||
          programs.futureskills2 ||
          programs.futureskills3
        }
      >
        <ProgramSection
          color={content.programs.Footer.ThemeColor}
          programName={['futureskills1', 'futureskills2']}
        />
        <ProgramSection
          color={content.programs.Footer.ThemeColor}
          programName="futureskills3"
        />
      </Content>
      {/* <Team id="team" pageName="Team" /> */}
      {/* <Advisors
        id="advisors"
        folder="advisors"
        pageName="Advisors"
        title="Program Advisors"
        margin="40px auto 0px"
      /> */}
      <Partners
        id="partners"
        title="With Support From"
        pageName="futureskills"
        margin="0px auto 0px"
      />
      <FaqComponent pageName="futureskills" />
      <Signups pageName="futureskills" />
      <Footer pageName="futureskills" />
    </Section>
  );
}
